export type Doc = {
  id: number;
  url: string;
  fileSize: number;
};

type DocMeta = {
  id: number;
  fileName: string;
}

export type Docs = {
  collection: Doc[];
  order: DocMeta[];
};

export type DocsDownload = Docs;

export type DocsUpload = {
  order: DocMeta[];
};

export const emptyDocs: () => Docs = () => ({
  collection: [],
  order: []
});

export const sampleDocs: () => Docs = () => ({
  collection: [
    {
      id: 0,
      url: 'https://sol-media-test.imgix.net/fakeData/cat1.jpg',
      fileSize: 2500,
    },
    {
      id: 1,
      url: 'https://sol-media-test.imgix.net/fakeData/cat5.jpg',
      fileSize: 2500000,
    },
  ],
  order: [{
    id: 1,
    fileName: 'cat5.jpg',
  }, {
    id: 0,
    fileName: 'cat1.jpg',
  }],
});

export const docsFromApi: (_: DocsDownload) => Docs = (d) => d;

export const docsToApi: (_: Docs) => DocsUpload = ({ order }) => ({order});
